export const formatPrice = function(value){
  let val = (value==null?0:(value/1)).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}